import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import { OnboardingWrapper } from '../../features/onboarding';
import { MemberOnboardingWrapper } from '../../features/onboarding';
import InviteOnboardingWizard from '../../features/onboarding/member-components/InviteOnboardingWizard';
import { Auth } from '../../features/auth';
import { MemberDashboard } from '../../features/member-dashboard';
import OTPVerification from '../../features/auth/components/OTPVerification';
import PaymentTrackingDashboard from '../../features/payment-tracking/PaymentTrackingDashboard';
import GroupPaymentDashboard from '../../features/payment-tracking/components/GroupPaymentDashboard';
import AddMemberForm from '../../features/group-setup/components/AddMemberForm';
import RotationView from '../../features/rotation-manager/components/RotationView';
import FAQPage from '../../features/support/components/FAQPage';
import HowToPage from '../../features/support/components/HowToPage';
import ProtectedRoute from '../../shared/components/ProtectedRoute';

// The legacy /group/:groupId/manage hub is retired — its group summary, invite
// link, and Manage Members (view/edit/reassign/remove + per-member invite links)
// all live in the Group Settings modal now. Redirect any stale link to the
// group's normal view (Payment Tracking), preserving groupId. The hub components
// (GroupSetupWrapper/GroupSetup/GroupDashboard/…) remain in the repo but are no
// longer reachable by URL.
const ManageRedirect = () => {
  const { groupId } = useParams();
  return <Navigate to={`/admin/group/${groupId}/payments`} replace />;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/auth/*" element={<Auth />} />
      <Route path="/signin" element={<Auth />} />
      <Route path="/verify" element={<OTPVerification />} />
      <Route path="/join/:groupId" element={<MemberOnboardingWrapper />} />
      <Route path="/invite/:token" element={<InviteOnboardingWizard />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/how-to" element={<HowToPage />} />

      {/* Admin-only routes */}
      <Route path="/onboarding" element={
        <ProtectedRoute requiredRole="admin"><OnboardingWrapper /></ProtectedRoute>
      } />
      <Route path="/group/:groupId/manage" element={
        <ProtectedRoute requiredRole="admin"><ManageRedirect /></ProtectedRoute>
      } />
      <Route path="/admin/dashboard" element={
        <ProtectedRoute requiredRole="admin"><PaymentTrackingDashboard /></ProtectedRoute>
      } />
      <Route path="/admin/group/:groupId/payments" element={
        <ProtectedRoute requiredRole="admin"><GroupPaymentDashboard /></ProtectedRoute>
      } />
      <Route path="/admin/group/:groupId/rotation" element={
        <ProtectedRoute requiredRole="admin"><RotationView /></ProtectedRoute>
      } />
      <Route path="/admin/group/:groupId/add-member" element={
        <ProtectedRoute requiredRole="admin"><AddMemberForm /></ProtectedRoute>
      } />

      {/* Member-only routes */}
      <Route path="/member/dashboard" element={
        <ProtectedRoute requiredRole="member"><MemberDashboard /></ProtectedRoute>
      } />

      {/* Default */}
      <Route path="/" element={<Auth />} />
      <Route path="/*" element={<Auth />} />
    </Routes>
  );
};

export default AppRoutes;
